var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisablelock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 93,
    fill: "none",
    stroke: "#e4e3e3",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 87V75a12 12 0 0 1 24 0v12",
    fill: "none",
    stroke: "#e4e3e3",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 84,
    width: 54,
    height: 47,
    rx: 10,
    fill: "#e4e3e3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisablelock);
export default __webpack_public_path__ + "static/media/disablelock.af20304b51f125347b9684794eba5bd3.svg";
export { ForwardRef as ReactComponent };